 <div class="head">
   Field History
</div>
<div style="width:100%; background-color: #3F51B5">&nbsp;</div>
@for(r of results; track $index){
<div class="tbl">
  <div style="padding:5px;border: solid 1px lightgray;" class="row-item">
    {{r.newValue}}
    <div>{{r.updatedDate}} by {{r.email}}</div> 
  </div>
</div>
}
